<template>
  <page :load="doInit">
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <form data-vv-scope="mulAcctPaymentFilter">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <div slot="header">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn class="mx-2" fab dark small color="teal" v-on="on" @click.native.stop="showFilterList = true">
                          <v-icon dark>mdi-format-list-bulleted</v-icon>
                        </v-btn>
                      </template>
                      <span>Show Saved Filters</span>
                    </v-tooltip>
                    Filters <span color="primary">{{ defaultFilter.filterName !== undefined ? ' > ' + defaultFilter.filterName : '' }}</span>
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                            <v-text-field
                              v-model="mulAcctPayFilterForm.branch"
                              :label="mulAcctPayFilterLabel.branch"
                              :error-messages="errors.collect('branch')"
                              data-vv-name="branch"
                              :data-vv-as="mulAcctPayFilterLabel.branch"
                              v-validate="'entry|max:60'"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="showBranchHelpList = true">mdi-magnify</v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md3 xl2 class="lg4-custom">
                            <v-text-field
                              v-model="mulAcctPayFilterForm.accountNo"
                              :label="mulAcctPayFilterLabel.accountNo"
                              :error-messages="errors.collect('accountNo')"
                              data-vv-name="accountNo"
                              :data-vv-as="mulAcctPayFilterLabel.accountNo"
                              v-validate="'entry|max:60'"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="showAcctNoHelpList = true">mdi-magnify</v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md3 xl2 class="lg4-custom">
                            <v-text-field
                              v-model="mulAcctPayFilterForm.documentNo"
                              :label="mulAcctPayFilterLabel.documentNo"
                              :error-messages="errors.collect('documentNo')"
                              data-vv-name="documentNo"
                              :data-vv-as="mulAcctPayFilterLabel.documentNo"
                              v-validate="'entry|max:60'"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="showDocNoHelpList = true">mdi-magnify</v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md3 xl2 class="lg4-custom">
                            <v-text-field
                              v-model="mulAcctPayFilterForm.currency"
                              :label="mulAcctPayFilterLabel.currency"
                              :error-messages="errors.collect('currency')"
                              data-vv-name="currency"
                              :data-vv-as="mulAcctPayFilterLabel.currency"
                              v-validate="'entry|max:60'"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="showCurrencyHelpList = true">mdi-magnify</v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <cal-picker
                              v-model="mulAcctPayFilterForm.transactionDateFrom"
                              :label="mulAcctPayFilterLabel.transactionDateFrom"
                              :data-vv-as="mulAcctPayFilterLabel.transactionDateFrom"
                              data-vv-name="transactionDateFrom"
                            ></cal-picker>
                          </v-flex>
                          <v-flex xs6>
                            <cal-picker
                              v-model="mulAcctPayFilterForm.transactionDateTo"
                              :label="mulAcctPayFilterLabel.transactionDateTo"
                              :data-vv-as="mulAcctPayFilterLabel.transactionDateTo"
                              data-vv-name="transactionDateTo"
                            ></cal-picker>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-layout row wrap>
                      <v-spacer></v-spacer>
                      <v-card-actions>
                        <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text @click.native="saveFilter = true">Save Current Filters</v-btn>
                        <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-layout>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-flex class="text-right">
              <v-btn color="primary" @click.native="doCreateMulAcctPay">
                <span>{{ lblCreateMulAcctPay }}</span>
                <v-icon right dark>mdi-plus</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-data-table
                  v-bind:headers="listPaymtHeaders"
                  v-bind:items="items"
                  :server-items-length="totalItems"
                  :footer-props="{'items-per-page-options': itemsPerPage }"
                  v-bind:options.sync="pagination"
                  item-key="key"
                  :loading="loading"
                  :no-data-text="noDataText"
                >
                  <template v-slot:item="row"
                    ><tr>
                      <td v-for="column in selectedPaymentColumns" :key="column">{{ row.item[column] }}</td>
                      <td class="table-action-header">
                        <table-action
                          :rowData="row"
                          query
                          @query="doQuery(row.item)"
                          review
                          @review="doReview(row.item)"
                          :remove="canRemove(row.item)"
                          @remove="doPromptRemove(row.item)"
                        ></table-action>
                      </td></tr
                  ></template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="showBranchHelpList" width="1280px">
        <branch-help-list @close="showBranchHelpList = false" @assign-branch="assignBranch"></branch-help-list>
      </v-dialog>
      <v-dialog v-model="showAcctNoHelpList" width="1280px">
        <cr-acct-no-help-list @close="showAcctNoHelpList = false" @assign-acct-no="assignAcctNo"></cr-acct-no-help-list>
      </v-dialog>
      <v-dialog v-model="showDocNoHelpList" width="1280px">
        <paymt-doc-no-help-list @close="showDocNoHelpList = false" @assign-doc-no="assignDocNo"></paymt-doc-no-help-list>
      </v-dialog>
      <v-dialog v-model="showCurrencyHelpList" width="1280px">
        <cr-currency-help-list @close="showCurrencyHelpList = false" @assign-currency="assignCurr"></cr-currency-help-list>
      </v-dialog>
      <!--Start Delete Prompt -->
      <confirm v-model="promptRemove" @ok="doRemove">
        <p>{{ lblPromptRemove }}</p>
        <div class="queryValue">
          Branch: {{ selected.branch }}<br />
          Doc. No.: {{ selected.documentNo }}<br />
          Tran Type: {{ selected.transactionType }}
        </div>
      </confirm>
      <!-- End Delete Prompt-->
      <v-dialog v-model="showFilterList" width="800px" persistent>
        <SearchFilter
          :boolRefresh="showFilterList"
          :filterTitle="'Saved Filters - Accounts Listing'"
          @close="showFilterList = false"
          :filterCode="filterCode"
          @applyDefaultFilter="applyDefaultFilter"
        ></SearchFilter>
      </v-dialog>
      <v-dialog v-model="saveFilter" width="800px" persistent>
        <UpdateSearchFilter
          :boolRefresh="saveFilter"
          :dialogTitle="'Filter'"
          :actionName="'new'"
          :filters="mulAcctPayFilterForm"
          @close="saveFilter = false"
          @reloadList="reloadList"
          :filterCode="filterCode"
          @applyDefaultFilter="applyDefaultFilter"
        ></UpdateSearchFilter>
      </v-dialog>
    </v-container>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import { mapGetters } from 'vuex'
import BranchHelpList from '@/components/core/common/dialog/BranchHelpList'
import CrAcctNoHelpList from '@/components/core/common/dialog/CrAcctNoHelpList'
import PaymtDocNoHelpList from '@/components/core/common/dialog/PaymtDocNoHelpList'
import CrCurrencyHelpList from '@/components/core/common/dialog/CrCurrencyHelpList'
import { mulAcctPaymentViewMixin } from '@/mixins/accounting/payment/mulAcctPayt/mulAcctPaymentViewMixin'
import { mulAcctPaymentAjaxMixin } from '@/mixins/accounting/payment/mulAcctPayt/mulAcctPaymentAjaxMixin'
import { PAYMENT_LOAD_DATA } from '@/store/types'
import SearchFilter from '@/components/core/common/dialog/SearchFilter'
import UpdateSearchFilter from '@/components/core/common/dialog/UpdateSearchFilter'
import { expandURI } from '@/utils/ajax'
import { recordLockMixin } from '@/mixins/common/recordLockMixin'
import { strJoin } from '@/utils/stringutil'

export default {
  data() {
    return {
      showBranchHelpList: false,
      lblCreateMulAcctPay: 'New Payment',
      lblPromptRemove: 'Are you sure you want to delete the selected Payment?',
      loading: false,
      items: [],
      totalItems: 0,
      selectedPage: 0,
      pagination: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      selectedPaymentColumns: ['branch', 'accountNo', 'documentNo', 'tranDate', 'currency', 'amount', 'gst', 'bankOrigAmt', 'bankLocTot'],
      paymentColumns: [
        { text: 'Branch', value: 'branch' },
        { text: 'Acct. No.', value: 'accountNo' },
        { text: 'Doc. No.', value: 'documentNo' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Currency', value: 'currency' },
        { text: 'Amount ', value: 'amount' },
        { text: 'GST', value: 'gst' },
        { text: 'Bank Amount', value: 'bankOrigAmt' },
        { text: 'Local Bank Amount', value: 'bankLocTot' }
      ],
      paymentData: {
        tranMode: '',
        branch: '',
        accountNo: '',
        type: '',
        documentNo: '',
        fund: '',
        suffix: ''
      },
      showAcctNoHelpList: false,
      showDocNoHelpList: false,
      filtersDocNoLabel: {
        documentNo: 'Document No.'
      },
      filtersDocNo: {
        documentNo: undefined
      },
      docNoItems: [],
      totalItemsDocNo: 0,
      docNoHeaders: [
        { text: 'Document No.', align: 'left', value: 'documentNo' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationDocNo: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      showCurrencyHelpList: false,
      selected: {
        branch: '',
        documentNo: '',
        transactionType: ''
      },
      promptRemove: false,
      filterCode: 'MPY',
      newFilter: false,
      saveFilter: false,
      showFilterList: false,
      defaultFilter: {}
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('paymentInit')])
      await Promise.all([this.$store.dispatch('searchFilterInit')])
      this.getDefaultFilter()
      if (this.initPayment === 1) {
        this.performSearchMultAcctPayt()
      }
      this.$store.commit(PAYMENT_LOAD_DATA, this.paymentData)
    },
    doCreateMulAcctPay() {
      this.$router.push({ name: 'createMulAcctPayment' }).catch(() => {})
    },
    doClearFilters() {
      var thisPage = this
      Object.keys(this.mulAcctPayFilterForm).forEach(function(key, index) {
        thisPage.mulAcctPayFilterForm[key] = ''
      })
      this.performSearchMultAcctPayt()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('mulAcctPaymentFilter').then(result => {
        if (result) {
          this.pagination.page = 1
          this.performSearchMultAcctPayt()
        }
      })
    },
    doReview(data) {
      // AR: OS-660 Added to check if record is locked 2021-01-29
      let recKey = strJoin('|', 'MUL', data.type, data.branch, data.documentNo, data.fund)
      this.checkRecordLock(recKey, 'ACT').then(result => {
        // Record not locked proceed to review 2021-01-29
        if (!result) {
          this.performReview(data)
          // Record was locked show message 2021-01-29
        } else {
          this.loading = false
        }
      })
    },
    performReview(data) {
      if (data) {
        data.tranMode = 'R'
        this.$store.commit(PAYMENT_LOAD_DATA, data)
        this.$router.push({ name: 'createMulAcctPayment' }).catch(() => {})
      } else {
        this.loading = false
      }
    },
    doQuery(data) {
      data.tranMode = 'Q'
      this.$store.commit(PAYMENT_LOAD_DATA, data)
      this.$router.push({ name: 'queryMulAcctPayment' }).catch(() => {})
    },
    doPromptRemove(item) {
      this.selected.branch = item.branch
      this.selected.documentNo = item.documentNo
      this.selected.transactionType = item.type
      this.promptRemove = true
    },
    doRemove() {
      this.delMultAcctPayt(this.selected)
      this.promptRemove = false
    },
    assignBranch(data) {
      this.mulAcctPayFilterForm.branch = data
      this.showBranchHelpList = false
    },
    assignAcctNo(acctNo) {
      this.mulAcctPayFilterForm.accountNo = acctNo
      this.showAcctNoHelpList = false
    },
    assignDocNo(docNo) {
      this.mulAcctPayFilterForm.documentNo = docNo
      this.showDocNoHelpList = false
    },
    assignCurr(curr) {
      this.mulAcctPayFilterForm.currency = curr
      this.showCurrencyHelpList = false
    },
    reloadList(filterName) {
      this.defaultFilter.filterName = filterName
      this.saveFilter = false
      this.performSearchMultAcctPayt()
    },
    applyDefaultFilter(filterData) {
      this.defaultFilter = filterData
      if (this.defaultFilter.filters !== undefined) {
        this.mulAcctPayFilterForm = this.defaultFilter.filters
      }
      this.showFilterList = false
      this.performSearchMultAcctPayt(false)
    },
    async getDefaultFilter() {
      const apiUrl = this.$store.state.searchFilter.menu.defaultFilter
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            filterCode: this.filterCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          this.initialLoad = false
          if (data) {
            this.defaultFilter.filterName = data.defaultFilter.filterName
            this.defaultFilter.filterDesc = data.defaultFilter.filterDesc
            this.defaultFilter.filterCode = data.defaultFilter.filterCode
            this.defaultFilter.filters = JSON.parse(data.defaultFilter.filterContent)
            if (this.defaultFilter.filters !== undefined) {
              this.mulAcctPayFilterForm = this.defaultFilter.filters
            }
            this.performSearchMultAcctPayt(false)
          } else {
            this.performSearchMultAcctPayt(false)
          }
        } catch (err) {
          this.loading = false
        }
      }
    },
    canRemove(data) {
      if (data.postNow === 'N' && data.void_ === false) {
        return true
      }
      return false
    }
  },
  computed: {
    ...mapGetters(['checkAccess']),
    initPayment() {
      return this.$store.state.payment.init
    },
    listPaymtHeaders() {
      let result = []
      for (const selectedPaymtColumn of this.selectedPaymentColumns) {
        let findCol = this.paymentColumns.find(a => selectedPaymtColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  watch: {
    'paginationDocNo': function(value) {
      this.fetchPaymtDocNoData()
    },
    'pagination': function(value) {
      this.performSearchMultAcctPayt(false)
    }
  },
  mounted() {
    // AR: OS-660 Added to check record lock 2021-01-21
    this.initCommonUtilMenu()
  },
  mixins: [routeMixin, MessageMixin, TableConst.default, mulAcctPaymentViewMixin, mulAcctPaymentAjaxMixin, recordLockMixin],
  components: {
    BranchHelpList,
    CrAcctNoHelpList,
    PaymtDocNoHelpList,
    CrCurrencyHelpList,
    SearchFilter,
    UpdateSearchFilter
  }
}
</script>
<style lang="scss"></style>
